import {useEffect, useState} from "react";
import {API, Card, Endpoints} from "@brg/api";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";


export const useGetCards = (cardIds: string[], isProductCards?: boolean) => {

    const [cards, setCards] = useState<Card<'Global'>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { i18n: {language} } = useTranslation();
    const profile = useProfile();

    useEffect(() => {
        if ((profile?.accountId || isProductCards) && cardIds && cardIds.length > 0) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', cardIds)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setCards(API.toLang(r, language) as Card<'Global'>[])
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [language, profile?.accountId, isProductCards, cardIds])

    return {cards, isLoading, error}
}

export const useGetCard = (cardId: any, disabled?: any) => {
    const [card, setCard] = useState(undefined)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
  
    useEffect(() => {
      if (!disabled && cardId) {
        setIsLoading(true)
        API.request()
          .endpoint(Endpoints.cardsMnePw)
          .url('/api/Card/GetCard')
          .addQuery('id', cardId)
          .get()
          .send()
          .then((r) => r.json())
          .then((r) => {
            setIsLoading(false)
            setCard(r)
          })
          .catch((e) => {
            setIsLoading(false)
            setError(true)
          })
      }
    }, [cardId, disabled])
  
    return { card, isLoading, error }
  }import {useEffect, useState} from "react";
import {API, Card, Endpoints} from "@brg/api";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";


export const useGetCards = (cardIds: string[], isProductCards?: boolean) => {

    const [cards, setCards] = useState<Card<'Global'>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { i18n: {language} } = useTranslation();
    const profile = useProfile();

    useEffect(() => {
        if ((profile?.accountId || isProductCards) && cardIds && cardIds.length > 0) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', cardIds)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setCards(API.toLang(r, language) as Card<'Global'>[])
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [language, profile?.accountId, isProductCards, cardIds])

    return {cards, isLoading, error}
}

export const useGetCard = (cardId: any, disabled?: any) => {
    const [card, setCard] = useState(undefined)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
  
    useEffect(() => {
      if (!disabled && cardId) {
        setIsLoading(true)
        API.request()
          .endpoint(Endpoints.cardsMnePw)
          .url('/api/Card/GetCard')
          .addQuery('id', cardId)
          .get()
          .send()
          .then((r) => r.json())
          .then((r) => {
            setIsLoading(false)
            setCard(r)
          })
          .catch((e) => {
            setIsLoading(false)
            setError(true)
          })
      }
    }, [cardId, disabled])
  
    return { card, isLoading, error }
  }